// extracted by mini-css-extract-plugin
export default {"container":"CommonModal_container__IciDk"};